export * from './getAwsWafTokenDomain';
